import {useNavigation, useRoute, RouteProp} from '@react-navigation/native';
import React, {useState} from 'react';
import {
  Alert,
  ImageBackground,
  Keyboard,
  KeyboardAvoidingView,
  Platform,
  ScrollView,
  Text,
  TouchableOpacity,
  TouchableWithoutFeedback,
  View,
} from 'react-native';
import FontAwesome6 from 'react-native-vector-icons/FontAwesome6';
import ButtonComponent from '../../../components/ButtonComponent/ButtonComponent';
import Input from '../../../components/Input/Input';
import {Colors} from '../../../constants/Colors';
import AuthService from '../../../services/AuthService/AuthService';
import {
  basePasswordSchema,
  confirmPasswordSchema,
  numberSchema,
  specialCharSchema,
} from '../../../schemas/AuthSchema';
import ShowMessagePass from '../Register/RegisterForm/components/ShowMessagePass';
import {NavigationProps} from '../../../navigation/Routes';
import {AppRoutes} from '../../../navigation/Routes.types';
import {RootStackParamList} from '../../../navigation/Routes.types';
import {useLoadingStore} from '../../../store/LoadingStore';
import {styles} from './styles';
import { showSuccess } from '../../../utils/globalAlert';

const NewPasswordScreen = () => {
  const {navigate, goBack} = useNavigation<NavigationProps>();
  const route = useRoute<RouteProp<RootStackParamList, AppRoutes.NEW_PASSWORD>>();
  const {user, token} = route.params ?? {user: '', token: ''};

  const [password, setPassword] = useState('');
  const [confirmPassword, setConfirmPassword] = useState('');
  const [errorsMessage, setErrorsMessage] = useState<string[]>([]);
  const {hideLoading, showLoading} = useLoadingStore();

  const validatePassword = (pwd: string) => {
    const resultBase = basePasswordSchema.safeParse({senha: pwd});
    const resultNumber = numberSchema.safeParse({senha: pwd});
    const resultSpecial = specialCharSchema.safeParse({senha: pwd});
    const errs: string[] = [];
    if (resultBase.success === false && resultBase.error.errors[0]) {
      errs.push(resultBase.error.errors[0].message);
    }
    if (resultNumber.success === false && resultNumber.error.errors[0]) {
      errs.push(resultNumber.error.errors[0].message);
    }
    if (resultSpecial.success === false && resultSpecial.error.errors[0]) {
      errs.push(resultSpecial.error.errors[0].message);
    }
    setErrorsMessage(errs);
  };

  const handleSubmit = async () => {
    const resultBase = basePasswordSchema.safeParse({senha: password});
    const resultNumber = numberSchema.safeParse({senha: password});
    const resultSpecial = specialCharSchema.safeParse({senha: password});
    const resultConfirm = confirmPasswordSchema.safeParse({
      password,
      confirmPassword,
    });

    if (
      !resultBase.success ||
      !resultNumber.success ||
      !resultSpecial.success ||
      !resultConfirm.success
    ) {
      if (!resultConfirm.success && resultConfirm.error.errors[0]) {
        Alert.alert('Opss...', resultConfirm.error.errors[0].message);
      } else {
        validatePassword(password);
        Alert.alert('Opss...', 'A senha não atende aos requisitos.');
      }
      return;
    }

    showLoading();
    try {
      await AuthService.confirmResetPasswordPost({
        user,
        token,
        password,
        confirmPassword,
      });
      hideLoading();
      showSuccess(
        'Conecta Brasal',
        'Sua senha foi alterada com sucesso. Faça login com a nova senha.',
        [{text: 'OK', onPress: () => navigate(AppRoutes.LOGIN)}],
      );
    } catch (error: any) {
      hideLoading();
      const errorMessage =
        error?.response?.data?.details ||
        error?.response?.data?.message ||
        'Erro ao alterar senha. Tente novamente.';
      Alert.alert('Opss...', String(errorMessage));
    }
  };

  return (
    <TouchableWithoutFeedback onPress={Keyboard.dismiss}>
      <ImageBackground style={styles.imageBackground}>
        <KeyboardAvoidingView
          behavior={Platform.OS === 'ios' ? 'padding' : 'height'}
          style={styles.container}>
          <ScrollView showsVerticalScrollIndicator={false} keyboardShouldPersistTaps="handled">
            <TouchableOpacity onPress={goBack} style={styles.arrowButton}>
              <FontAwesome6
                name="arrow-left"
                color={Colors.GrayPallete.lightgrayThree}
                size={22}
              />
            </TouchableOpacity>
            <Text style={styles.recover}>Nova senha</Text>
            <Text style={styles.description}>
              Defina uma nova senha para acessar sua conta. Ela deve ter pelo
              menos 6 caracteres, letras maiúscula e minúscula, um número e um
              caractere especial.
            </Text>
            <Input
              title="Nova senha"
              placeholder="**************"
              mt={20}
              hasSecurity
              value={password}
              onChangeText={(text) => {
                setPassword(text);
                validatePassword(text);
              }}
            />
            {password.length > 0 && <ShowMessagePass errorsMessage={errorsMessage} />}
            <Input
              title="Confirme a senha"
              placeholder="Confirme a senha..."
              mt={20}
              hasSecurity
              value={confirmPassword}
              onChangeText={setConfirmPassword}
            />
            <View style={styles.containerButton}>
              <ButtonComponent title="Alterar senha" onPress={handleSubmit} />
            </View>
            <View style={styles.containerBack}>
              <TouchableOpacity onPress={goBack}>
                <Text style={styles.goBack}>Voltar</Text>
              </TouchableOpacity>
            </View>
          </ScrollView>
        </KeyboardAvoidingView>
      </ImageBackground>
    </TouchableWithoutFeedback>
  );
};

export default NewPasswordScreen;
